"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultListYourPropertyTestimonials = exports.defaultListYourPropertyTestimonial = void 0;
exports.defaultListYourPropertyTestimonial = {
    image: 'https://ww2.okay.com/commoncontent/images/listproperty/ourclients/testimonial-2.jpg',
    name: 'Shirley Wong',
    text: 'I managed to reach an agreement on the same day of a tenant’s initial viewing due to the professionalism of my OKAY.com agent during the negotiation process. I went on to appoint OKAY.com as the sole agent for one of my other properties and was once again impressed by the fantastic combination of my agent’s skills and the company’s broad client base.'
};
exports.defaultListYourPropertyTestimonials = [
    exports.defaultListYourPropertyTestimonial, exports.defaultListYourPropertyTestimonial
];
